// extracted by mini-css-extract-plugin
export default {"governance_header":"GovernanceHeader_governance_header__WkPrN"};